import axios from "axios";
import { stringify } from "query-string";


export const getAccessToken = (code) => {
  let oidcURL = `${import.meta.env.VITE_APP_OIDC_URL}`;
  let params = stringify({
    grant_type: "authorization_code",
    redirect_uri: `https://${window.location.host}/dashboard`,
    client_id: import.meta.env.VITE_APP_CLIENT_ID,
    code,
    client_secret: import.meta.env.VITE_APP_CLIENT_SECRET
  });

  return axios
    .post(oidcURL, params, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    })
    .then((res) => {
      return res.data;
    })
    .finally(() => {
      console.log("Successfull");
    });
};

export const generateAuthUrl = () => {
  let oidcURL = `${import.meta.env.VITE_APP_OIDC_IDP_URL}/login/continue`;
    let params = stringify({
      client_id: import.meta.env.VITE_APP_CLIENT_ID,
      response_type: "code",
      scope: "email+openid+profile",
      redirect_uri:  `${window.location.origin}/dashboard`,
    });
    params = params.replace(/%2B/g, "+");
    return `${oidcURL}?${params}`;
};

